var _defs, _path, _line, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTempsMortHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #4970b6;\n        stroke-linejoin: round;\n        stroke-width: 1.81px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.74,8.01s31.4,3.99,35.2,4.82c0,0,9.27,1.48,14.83,1.3,0,0,4.82.19,7.14,1.11,0,0,7.04.46,8.06,1.3,0,0,6.4,0,6.03,1.39,0,0,5.56,1.48,8.9,2.41,0,0,4.26-.65,4.36,1.67,0,0,.09,2.13-3.06,2.22,0,0-4.91.56-5.93,0,0,0-6.03.37-7.04-.37h-3.71s.46,2.69-5.56,1.85c0,0-2.97-.19-3.24-1.02,0,0-5.28-.56-10.85,3.24,0,0-6.95,2.87-11.68-.93,0,0-1.48-3.06-5.28-2.87,0,0-26.19-.93-28.16,1.58"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104,
    y1: 17.93,
    x2: 97.98,
    y2: 16.54
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.26,21.45s-.28.56-1.48.28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.54,17.93s8.9-2.11,15.76.57c0,0,2.6,2.12,5.65,3.74,0,0,.83.7.56,1.62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.51,23.1l-3.06-1.64s-1.39,1.76-1.39,2.78l2.22,1.61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.77,22.24h-.65c-1.21-.32-2.22-.61-2.22-.61-1.21-.56,0-1.29,0-1.29,0,0,2.47-.63,2.87,1.39,0,0,.47,2.33-1.58,2.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.56,24.74s.57,6.35,1.22,8.39c0,0,1.02,5.56.65,8.25,0,0,.37,4.36,1.02,5.19,0,0,1.76,2.32.93,7.04,0,0-.39,14.83.22,19.28,0,0,.52,13.07.52,19.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.94,26.23s-.48,4.96.54,5.33c0,0-.37,3.15.37,4.73,0,0,.19.83,0,1.39-.05,1.25.04,3.42.46,3.87,0,0-2.69,5.68-1.95,11.61,0,0,1.39,1.9-1.39,5.21,0,0-3.34,5.17-.46,12.49,0,0,.19,13.44-2.5,20.02"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.97,61.87c1.21-4.26-1.41-10.57-1.41-10.57.07-1.95-.63-3.15-.63-3.15l-.09-6.07c-.01-.97-.72-1.21-1.51-1.16,0,0-2.02,0-2.02.75v2.97c.85,1.71,3.62.83,3.62.83"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.51,25.31s1.8,3.65,1.6,5.41c0,0,3.15,9.08,3.32,10.66"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.11,24.74s.17,3.11.82,4.87c0,0,2.53,9.31,2.57,11.05"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.9,20.34s-8.34-1.95-14.46-2.41c0,0-6.34-.5-9.6-2.04,0,0-6.53-1.58-10.51-.93"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempsMortHand);
export default __webpack_public_path__ + "static/media/temps_mort_Hand.8473d1c54e766d8f0ddd7f0d1c65777d.svg";
export { ForwardRef as ReactComponent };